<section class="h-100">
  <div class="container-fluid h-100">
    <div class="row justify-content-center align-content-center">
      <div class="col-5 pe-0 ">
        <div class="card">
          <div class="card-body d-flex flex-column">
            <div class=" col-12 success  mt-5 text-center  mb-4 icon-modal_success"></div>
            <h3 class="text-center mt-1 mb-4 fw-bold">¡Felicidades!</h3>
            <div class="text-center mb-4">Tu usuario y contraseña han sido <br>
              activadas exitosamente.
            </div>
            <div class="row justify-content-center mb-5">
              <div class="col-4 d-flex flex-column justify-content-center p-0">
                <button class="btn btn-primary mb-1" [routerLink]="['/login']">Ingresar</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
